import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { PageComponent } from "@components/page/page.component";
import { AnbudKontraktSearchService } from "~app/features/virkeskop/anbud-kontrakt/services/anbud-kontrakt-search.service";
import { KontraktSearchMinaFilterService } from "~app/features/virkeskop/anbud-kontrakt/sok-anbud-kontrakt/kontrakt-search-mina-filter/kontrakt-search-mina-filter.service";
import { KONTRAKT_FILTER_KEY, KONTRAKT_SEARCH_KEY } from "~app/features/virkeskop/anbud-kontrakt/sok-anbud-kontrakt/kontrakt-search-mina-filter/kontrakt-token-keys";
import { CommonTexts } from "~app/features/virkeskop/common/common-texts";
import { AnbudKontraktListComponent } from "../../virkeskop/anbud-kontrakt/anbud-kontrakt-list/anbud-kontrakt-list.component";
import { SokFPVAvtalComponent } from "./sok-avtal/sok-skogsvard-fpv-avtal.component";

@Component({
    selector: "rask-skogsvard-fpv-avtal",
    templateUrl: "./rask-skogsvard-fpv-avtal.component.html",
    styleUrls: ["./rask-skogsvard-fpv-avtal.component.scss"],
    providers: [
        { provide: KONTRAKT_FILTER_KEY,
            useValue: "virkeskop.skogsvardfpv.sparade" },
        KontraktSearchMinaFilterService,
        { provide: KONTRAKT_SEARCH_KEY,
            useValue: "virkeskop.skogsvardfpv.searchparams" },
        AnbudKontraktSearchService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        SokFPVAvtalComponent,
        AnbudKontraktListComponent
    ]
})
export class SkogsvardFPVAvtalComponent {
    texts = CommonTexts.texts;
    title = "Sök skogsvårdsuppdrag";

    private readonly router = inject(Router);

    skapaAnbudKontrakt = () => {
        this.router.navigate(["/skogsvardfpv/avtal/ny"]);
    };
}
